export const SCORING_CRITERIA = [
  { key: "annual_value_score",         weight: 15, label: "Annual purchasing value",              help: "Estimated USD value this customer would spend on our categories per year." },
  { key: "rfq_probability_score",      weight: 15, label: "RFQ probability",                       help: "How likely they are to issue formal RFQs we can bid on." },
  { key: "repeat_purchase_score",      weight: 12, label: "Repeat purchasing potential",           help: "Consumables / recurring vs one-off capital purchase." },
  { key: "payment_reliability_score",  weight: 12, label: "Payment reliability",                    help: "Country + org type risk. Govt/donor vs private SME." },
  { key: "decision_maker_ease_score",  weight: 8,  label: "Ease of identifying decision makers",    help: "Are DMs publicly listed / findable?" },
  { key: "contact_availability_score", weight: 8,  label: "Verified contact info availability",     help: "Direct email/phone reachability with source." },
  { key: "import_dependency_score",    weight: 8,  label: "Import dependency (country+industry)",   help: "Auto-defaulted from country-industry matrix; overrideable per lead." },
  { key: "logistics_ease_score",       weight: 7,  label: "Logistics ease from India/UAE",          help: "Freight, customs, port access." },
  { key: "competition_score",          weight: 7,  label: "Existing competition (10 = LEAST)",      help: "Higher score = less local competition." },
  { key: "market_growth_score",        weight: 3,  label: "Market growth (country+industry)",       help: "Auto-defaulted from country-industry matrix." },
  { key: "relationship_score",         weight: 5,  label: "Existing relationship / reference",      help: "Warm intro, prior contact, referral." },
  { key: "time_required_score",        weight: 0,  label: "Time to generate lead (tracked only)",   help: "Not scored. Tracked for productivity." },
];

export const TIER_META = {
  "Tier 1 - High Priority": {
    label: "Tier 1",
    className: "bg-amber-100 text-amber-800 border-amber-300",
    dot: "bg-amber-600",
  },
  "Tier 2 - Medium Priority": {
    label: "Tier 2",
    className: "bg-slate-100 text-slate-700 border-slate-300",
    dot: "bg-slate-500",
  },
  "Tier 3 - Long-Term Opportunity": {
    label: "Tier 3",
    className: "bg-slate-50 text-slate-500 border-slate-200",
    dot: "bg-slate-400",
  },
};

export const STATUS_META = {
  "New":         { className: "bg-sky-50 text-sky-700 border-sky-200" },
  "In Research": { className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  "Qualified":   { className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "Scored":      { className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "Tier 1":      { className: "bg-amber-100 text-amber-800 border-amber-300" },
  "Tier 2":      { className: "bg-slate-100 text-slate-700 border-slate-300" },
  "Tier 3":      { className: "bg-slate-50 text-slate-500 border-slate-200" },
  "Rejected":    { className: "bg-rose-50 text-rose-700 border-rose-200" },
};

export function tierFromScore(score) {
  if (score == null) return null;
  if (score >= 70) return "Tier 1 - High Priority";
  if (score >= 50) return "Tier 2 - Medium Priority";
  return "Tier 3 - Long-Term Opportunity";
}
